//import 'bootstrap/js/dist/alert';
import 'bootstrap/js/dist/button';
//import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
//import * as Modal from 'bootstrap/js/dist/modal'
//import 'bootstrap/js/dist/popover';
//import 'bootstrap/js/dist/scrollspy';
import 'bootstrap/js/dist/tab';
//import 'bootstrap/js/dist/toast';
//import 'bootstrap/js/dist/tooltip';

import setScrollPadding from "./assets/scripts/frontend/scrollPadding";
import generalSearch from "./assets/scripts/frontend/generalSearch";
import handleLightboxSetup from "./assets/scripts/frontend/lightboxSetup";
import showScrollTop from "./assets/scripts/frontend/scrollTop";
import menuInit from "./assets/scripts/frontend/menu";
import handleMegaMenu from "./assets/scripts/frontend/handleMegaMenu";
import handleOnLoadModals from "./assets/scripts/frontend/handleOnLoadModals";
import consentManager from "./assets/scripts/frontend/consentmanager";
import consentManagerHandleBackground from "./assets/scripts/frontend/consentManagerHandleBackground";
import longOrderedList from "./assets/scripts/frontend/longOrderedList";

let timeoutId = null;
const documentHeight = () => {
    clearTimeout(timeoutId); // avoid execution of previous timeouts
    timeoutId = setTimeout(() => {
        const doc = document.documentElement;
        doc.style.setProperty('--doc-height', `${window.innerHeight}px`)
    }, 200);
};

document.onreadystatechange = () => {
    if (document.readyState === 'complete') {
        generalSearch();
        handleLightboxSetup();
        showScrollTop();
        consentManager();
        consentManagerHandleBackground();
        handleOnLoadModals();
        longOrderedList();
        const tellOtherScriptsWeAreReady = new CustomEvent('umeIntraReadyStateComplete');
        document.dispatchEvent(tellOtherScriptsWeAreReady);



    }
}
window.addEventListener('load', () => {
    setScrollPadding();
    documentHeight();
    menuInit();
    handleMegaMenu();





});
let currentWidth = window.innerWidth;
window.addEventListener('resize', () => {

    if (currentWidth === window.innerWidth) return;

    handleMegaMenu(true);
    documentHeight();
    setScrollPadding();
    const tellOtherScriptsWeResized = new CustomEvent('umeIntraResized');
    document.dispatchEvent(tellOtherScriptsWeResized);

    currentWidth = window.innerWidth;

});
window.addEventListener('orientationchange', function () {
    handleMegaMenu(true);
    documentHeight();
    setScrollPadding();

});